<template>
  <div>
    <general-top-bar :title="$t('reports.productsAndOptionsReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="(loc, index) in locations" :key="index" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <!-- Totals Section -->
      <div v-if="ordersTableData.data && ordersTableData.data.length > 0" class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="card center-sales-report-stats" style="height: 100% !important;">
              <div class="card-content" v-loading="loading">
                <div class="report-container">
                  <div class="report-row" style="margin-bottom: 8px; font-weight: bold; border-bottom: 1px solid #ddd; padding-bottom: 5px;">
                    <div class="report-col left-align"></div>
                    <div class="report-col right-align" style="color: #25396F; font-weight: bold;">{{$t('reports.quantity')}}</div>
                    <div class="report-col right-align" style="color: #25396F; font-weight: bold;">{{$t('reports.fullPrice')}}</div>
                    <div class="report-col right-align" style="color: #25396F; font-weight: bold;">{{$t('reports.orderItemNetPrice')}}</div>
                    <div class="report-col right-align" style="color: #25396F; font-weight: bold;">{{$t('reports.vatAmount')}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.products')}}</div>
                    <div class="report-col right-align">{{Number(productTotals.quantity || 0)}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(productTotals.total || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(productTotals.net_value || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(productTotals.vat || 0))}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.options')}}</div>
                    <div class="report-col right-align">{{Number(optionTotals.quantity || 0)}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(optionTotals.total || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(optionTotals.net_value || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(optionTotals.vat || 0))}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.total')}}</div>
                    <div class="report-col right-align">{{Number(grandTotals.quantity || 0)}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(grandTotals.total || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(grandTotals.net_value || 0))}}</div>
                    <div class="report-col right-align">{{formatMoneyAmount(Number(grandTotals.vat || 0))}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="80" prop="product_id" label="ID">
              <template slot-scope="props">
                {{ props.row.product_id || '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="100" prop="type" :label="$t('reports.type')">
              <template slot-scope="props">
                {{ props.row.type ? $t('reports.' + props.row.type) : '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="150" prop="product_name" :label="$t('catalogCateg.name')">
              <template slot-scope="props">
                {{ props.row.product_name }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="quantity" :label="$t('reports.itemsSold')">
              <template slot-scope="props">
                {{ Number(props.row.quantity) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="100" prop="total" :label="$t('reports.fullPrice')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.total)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="100" prop="net_value" :label="$t('reports.orderItemNetPrice')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.net_value || 0)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="vat" :label="$t('reports.vatAmount')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.vat)) }}
              </template>
            </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import SearchableMultiSelect from 'src/components/UIComponents/Inputs/SearchableMultiSelect.vue'

export default {
  components: {
    GeneralTopBar,
    SearchableMultiSelect,
    [DatePicker.name]: DatePicker
  },
  props: {
    isProductsAndOptions: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isProductsAndOptions () {
      if (this.isProductsAndOptions) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
      }
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  // },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      ordersTableData: {},
      productTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      optionTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      grandTotals: {
        quantity: 0,
        vat: 0,
        net_value: 0,
        total: 0
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      }
    }
  },
  methods: {
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        console.log(allowedLocations)
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isProductsAndOptions) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.apiRequest('/reports/v2/products-and-options' + '?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data && response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.pagination ? response.pagination.total : response.data.table_data.length
            this.paginationProps.currentPage = response.pagination ? response.pagination.page : page
            this.paginationProps.pageSize = response.pagination ? response.pagination.perPage : pageSize

            // Set totals from response
            if (response.data.totals) {
              if (response.data.totals.products) {
                this.productTotals = {
                  quantity: response.data.totals.products.quantity || 0,
                  vat: response.data.totals.products.vat || 0,
                  net_value: response.data.totals.products.net_value || response.data.totals.products.net_total || 0,
                  total: response.data.totals.products.total || 0
                }
              }
              if (response.data.totals.options) {
                this.optionTotals = {
                  quantity: response.data.totals.options.quantity || 0,
                  vat: response.data.totals.options.vat || 0,
                  net_value: response.data.totals.options.net_value || response.data.totals.options.net_total || 0,
                  total: response.data.totals.options.total || 0
                }
              }
              if (response.data.totals.general) {
                this.grandTotals = {
                  quantity: response.data.totals.general.quantity || 0,
                  vat: response.data.totals.general.vat || 0,
                  net_value: response.data.totals.general.net_value || response.data.totals.general.net_total || 0,
                  total: response.data.totals.general.total || 0
                }
              }
            }
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = 20
            this.productTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            }
            this.optionTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            }
            this.grandTotals = {
              quantity: 0,
              vat: 0,
              net_value: 0,
              total: 0
            }
          }
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from
      let toDate = this.orders.valid[1] + ' ' + this.valid_to

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      this.loading = true
      this.apiRequest('/reports/v2/products-and-options-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/ProductsAndOptionsReport.vue